import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'statistics',
    path: '/statistics',
    component: () => import('../pages/StatisticsPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'statisticsDetails',
    path: '/statistics/:statisticsId',
    component: () => import('../pages/StatisticsDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'statisticsWizard',
    path: '/statistics/wizard',
    component: () => import('../pages/StatisticsWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'statisticsWizardCopy',
    path: '/statistics/wizard/:statisticsId/copy',
    component: () => import('../pages/StatisticsWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
